<template>
  <div class="text-center">
    <v-menu offset-y left min-width="116">
      <template #activator="{ on, attrs }">
        <v-btn
          fab
          small
          elevation="0"
          color="transparent"
          v-bind="attrs"
          v-on="on"
          @click.prevent
        >
          <v-icon color="grey darken-2">more_vert</v-icon>
        </v-btn>
      </template>
      <v-list class="py-0">
        <v-list-item
          v-for="item in menuItems"
          :key="item.action"
          :data-testid="item.testId"
          @click="$emit(item.action)"
        >
          <v-list-item-title :class="item.class">
            <v-icon
              class="material-icons-outlined"
              :class="item.class"
            >
              {{ item.icon }}
            </v-icon>
            {{ item.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'ReviewCardMenu',
  props: {
    archived: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['archive', 'unarchive', 'delete'],
  computed: {
    menuItems() {
      return [
        {
          text: this.archived ? 'Unarchive' : 'Archive',
          icon: 'inventory_2',
          class: 'grey--text text--darken-1',
          action: this.archived ? 'unarchive' : 'archive',
          testId: 'archive-button',
        },
        {
          icon: 'delete',
          text: 'Delete',
          class: 'error--text',
          action: 'delete',
          testId: 'delete-button',
        },
      ];
    },
  },
};
</script>
